// extracted by mini-css-extract-plugin
export default {"botaoPadrao":"styles_botaoPadrao__Y5xDx"};